exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-615fca61]{background-color:gray}\n", ""]);

// exports
